import {SDKMode} from '../shared-library.constants';

/** Whether the mode uses a native SDK (React Native or Flutter). */
export function isNativeSdkMode(sdkMode?: string): boolean {
  return sdkMode === SDKMode.ReactNative || sdkMode === SDKMode.Flutter;
}
